import { getConfig } from "@engaging-tech/ssr-config"
import * as Sentry from "@sentry/react"

export const destroyFreshchatWidget = () => {
  if (typeof window === "undefined") {
    return
  }

  const { fcWidget } = window

  if (!fcWidget) {
    return
  }

  fcWidget.destroy()
}

let appliedWidgetConfig = ""

export const showFreshchatWidget = async (
  widgetUuid,
  tags = ["workl"],
  userId,
  firstName,
  lastName,
  email
) => {
  if (typeof window === "undefined") {
    return
  }

  const { fcWidget } = window

  if (!fcWidget) {
    return
  }

  const config = getConfig()

  let widgetConfig = {
    token: config.fsKey,
    host: config.fsDomain
  }

  if (userId || firstName || lastName || widgetUuid) {
    widgetConfig = {
      ...widgetConfig,
      externalId: userId,
      firstName: firstName || "Guest",
      lastName,
      email,
      widgetUuid,
      tags
    }
  }

  const configString = JSON.stringify(widgetConfig)

  Sentry.addBreadcrumb({
    category: "freshchat",
    message: "Freshchat show requested",
    level: "info",
    data: {
      hasUser: !!userId,
      widgetUuid: widgetUuid || null,
      tags,
      isInitialized: fcWidget.isInitialized(),
      isLoaded: fcWidget.isLoaded()
    }
  })

  if (appliedWidgetConfig === configString) {
    Sentry.addBreadcrumb({
      category: "freshchat",
      message: "Freshchat config unchanged",
      level: "info"
    })

    return
  }

  const initFreshchat = () => {
    if (!window.fcWidget) {
      Sentry.addBreadcrumb({
        category: "freshchat",
        message: "Freshchat unavailable when initialising",
        level: "warning"
      })

      return
    }

    appliedWidgetConfig = configString
    window.fcWidget.init(widgetConfig)
  }

  if (fcWidget.isLoaded()) {
    Sentry.addBreadcrumb({
      category: "freshchat",
      message: "Freshchat destroying loaded widget",
      level: "info"
    })

    fcWidget.on("widget:destroyed", () => {
      Sentry.addBreadcrumb({
        category: "freshchat",
        message: "Freshchat widget destroyed; initialising new config",
        level: "info"
      })

      initFreshchat()
    })

    fcWidget.destroy()
  } else {
    Sentry.addBreadcrumb({
      category: "freshchat",
      message: "Freshchat initialising widget",
      level: "info"
    })

    initFreshchat()
  }
}
